import React from 'react';

var logo = require('../../../../../assets/images/logo.png');

export default function InvoiceHeader(props) {
	return (
		<div className="InvoiceHeader grid justify-items-center md:mx-2 min-w-80 my-2 p-2">
			<img src={logo} style={{ height: '100px' }} />
			<span>#00001RBO</span>
		</div>
	);
}